export const SET_PATIENT_VISITS = 'VisitsGlobalContext.SET_PATIENT_VISITS';
export const SET_CROSSPATIENT_VISITS = 'VisitsGlobalContext.SET_CROSSPATIENT_VISITS';
export const SET_PROVIDER_INFO = 'VisitsGlobalContext.SET_PROVIDER_INFO';
export const TOGGLE_FILTERING_ATTRIBUTE = 'VisitsGlobalContext.TOGGLE_FILTERING_ATTRIBUTE';
export const SET_TO_DATE = 'VisitsGlobalContext.SET_TO_DATE';
export const SET_FROM_DATE = 'VisitsGlobalContext.SET_FROM_DATE';
export const SET_OFFICE_FILTER = 'VisitsGlobalContext.SET_OFFICE_FILTER';
export const CLEAR_VISIT_FILTER = 'VisitsGlobalContext.CLEAR_VISIT_FILTER';
export const SET_FILTER_ATTRIBUTES = 'VisitsGlobalContext.SET_FILTER_ATTRIBUTES';
export const SET_FILTERED_VISITS = 'VisitsGlobalContext.SET_FILTERED_VISITS';
export const UPDATE_FILTERS = 'VisitsGlobalContext.UPDATE_FILTERS';
export const SET_DISCHARGE_INFO = 'VisitsGlobalContext.SET_DISCHARGE_INFO';
export const SET_MILEAGE = 'VisitsGlobalContext.SET_MILEAGE';
export const SET_TOLLS_FEES = 'VisitsGlobalContext.SET_TOLLS_FEES';
export const SET_TRANSIT_FEES = 'VisitsGlobalContext.SET_TRANSIT_FEES';
export const SET_START_TIME = 'VisitsGlobalContext.SET_START_TIME';
export const SET_TRAVEL_TIME = 'VisitsGlobalContext.SET_TRAVEL_TIME';
export const SET_CC_TIME = 'VisitsGlobalContext.SET_CC_TIME';
export const SET_TIME = 'VisitsGlobalContext.SET_TIME';
export const SET_EDIT_TIME = 'VisitsGlobalContext.SET_EDIT_TIME';
export const SET_REFRESH_VISIT = 'VisitsGlobalContext.SET_REFRESH_VISIT';
export const RESET_REFRESH_VISIT = 'VisitsGlobalContext.RESET_REFRESH_VISIT';
export const SET_VISIT_TYPES_OPTIONS = 'VisitsGlobalContext.SET_VISIT_TYPES_OPTIONS';
export const SET_VISIT_TYPE_OPTION = 'VisitsGlobalContext.SET_VISIT_TYPE_OPTION';
export const SET_DRIVING_VISIT = 'VisitsGlobalContext.SET_DRIVING_VISIT';
export const CLEAR_DRIVING_VISIT = 'VisitsGlobalContext.CLEAR_DRIVING_VISIT';
export const SHOW_DRIVING_EXPIRED_MODAL = 'VisitsGlobalContext.SHOW_DRIVING_EXPIRED_MODAL';
export const HIDE_DRIVING_EXPIRED_MODAL = 'VisitsGlobalContext.HIDE_DRIVING_EXPIRED_MODAL';